<template>
  <v-container fluid v-if="truckRequest">
    <v-row wrap v-if="truckRequest && user.role == 'Driver'">
      <v-col cols="12" class="headline pl-0">
        <v-btn
          color="primary"
          class="mr-2 pa-0"
          small
          outlined
          text
          to="/truck-requests/manage/driver"
          style="margin-top:-3px"
          ><v-icon>chevron_left</v-icon></v-btn
        >
        Request Details
      </v-col>
    </v-row>
    <!-- JOB DETAILS -->
    <v-row v-if="truckRequest">
      <v-col cols="12" sm="12" md="6" class="px-0">
        <truck-request-ticket :truckRequest="truckRequest" />
      </v-col>
    </v-row>
    <!-- MINI -->
    <v-row
      v-if="
        truckRequest &&
          truckRequest.requestType == 'Mini Pickup/Dropoff' &&
          truckRequest.status == 'scheduled'
      "
    >
      <v-col cols="12" sm="12" md="6" class="px-0">
        <v-card>
          <v-card-text class="px-1">
            <v-container fluid class="pt-0">
              <v-row>
                <v-col cols="12" xs="4">
                  <h3 class="font-weight-bold mb-0">
                    Mini Pickup/Dropoff
                  </h3>
                  <h4 class="red--text mb-4">
                    * PLEASE CONFIRM
                  </h4>
                  <v-text-field
                    v-model.number="truckRequest.miniDropoffQty"
                    type="number"
                    label="Mini Dropoff"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="4">
                  <v-text-field
                    v-model.number="truckRequest.miniPickupQty"
                    type="number"
                    label="Mini Pickup"
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
        <v-snackbar v-model="snack" :timeout="5000" :color="snackColor">
          {{ snackText }}
          <v-btn text @click="snack = false">Close</v-btn>
        </v-snackbar>
      </v-col>
    </v-row>
    <!-- PACKER/ROLLOFF -->
    <v-row
      v-if="
        truckRequest.requestType == 'Packer' &&
          truckRequest.status == 'scheduled'
      "
    >
      <v-col cols="12" sm="12" md="6" class="px-0">
        <v-card>
          <v-card-text class="px-1">
            <v-container fluid class="pt-0">
              <v-row>
                <v-col cols="12" xs="12">
                  <h3 class="font-weight-bold mb-0">
                    Quantity Confirmation
                  </h3>
                  <h4 class="red--text mb-4">
                    * PLEASE CONFIRM
                  </h4>

                  <v-switch
                    v-model="fullTruck"
                    label="Full Truck"
                    color="primary"
                    class="mt-0 mb-4 pb-6"
                    hide-details
                  ></v-switch>

                  <v-row>
                    <v-col cols="6" sm="6">
                      <v-text-field
                        v-model.number="quantityBreakdown.looseYardsRegular"
                        type="number"
                        label="Loose Yards Regular Debris"
                        outlined
                        dense
                        min="0"
                        step="0.1"
                        :disabled="fullTruck"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6">
                      <v-text-field
                        v-model.number="quantityBreakdown.looseYardsHeavy"
                        type="number"
                        label="Loose Yards Heavy Material"
                        hint="(masonry, dirt)"
                        persistent-hint
                        outlined
                        dense
                        min="0"
                        step="0.1"
                        :disabled="fullTruck"
                      >
                        <template v-slot:hint>
                          <span class="grey--text">(masonry, dirt)</span>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" sm="6">
                      <v-text-field
                        v-model.number="quantityBreakdown.minisRegular"
                        type="number"
                        label="Minis Emptied Regular Debris"
                        outlined
                        dense
                        min="0"
                        step="1"
                        :disabled="fullTruck"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6">
                      <v-text-field
                        v-model.number="quantityBreakdown.minisHeavy"
                        type="number"
                        label="Minis Emptied Heavy Material"
                        hint="(masonry, dirt)"
                        persistent-hint
                        outlined
                        dense
                        min="0"
                        step="1"
                        :disabled="fullTruck"
                      >
                        <template v-slot:hint>
                          <span class="grey--text">(masonry, dirt)</span>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
        <v-snackbar v-model="snack" :timeout="5000" :color="snackColor">
          {{ snackText }}
          <v-btn text @click="snack = false">Close</v-btn>
        </v-snackbar>
      </v-col>
    </v-row>
    <!-- MATERIAL BREAKDOWN - SIMPLIFIED 4 OPTIONS -->
    <v-row
      v-if="
        truckRequest.status == 'scheduled' &&
          truckRequest.requestType !== 'Mini Pickup/Dropoff'
      "
    >
      <v-col cols="12" sm="12" md="6" class="px-0">
        <v-card>
          <v-card-text class="px-1">
            <v-container fluid class="pt-0">
              <v-row>
                <v-col cols="12" xs="12">
                  <h3 class="font-weight-bold mb-0">
                    Material Breakdown
                  </h3>
                  <div class="mt-4">
                    <p class="mb-3">Select materials that were picked up:</p>
                    <v-chip-group
                      v-model="simplifiedMaterialTypes"
                      column
                      multiple
                    >
                      <v-chip filter outlined value="C&D" class="ma-1">
                        C&D
                      </v-chip>
                      <v-chip filter outlined value="Metal" class="ma-1">
                        Metal
                      </v-chip>
                      <v-chip filter outlined value="Masonry/Dirt" class="ma-1">
                        Masonry/Dirt
                      </v-chip>
                      <v-chip filter outlined value="Trees/Grass" class="ma-1">
                        Trees/Grass
                      </v-chip>
                    </v-chip-group>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- SIGNATURES - CLIENT -->
    <v-row v-if="truckRequest && truckRequest.status == 'scheduled'">
      <v-col cols="12" sm="12" md="6" class="px-0">
        <v-card>
          <v-card-text class="px-1">
            <v-container fluid>
              <v-row no-gutters class="mb-4">
                <v-col xs="12">
                  <h3 class="font-weight-bold mb-4">
                    CLIENT Signature
                    <!-- <v-btn
                        @click="showClientEmail = true"
                        v-if="!showClientEmail"
                        color="primary"
                        text
                        small
                        class="ml-3"
                        outlined
                        >Add email</v-btn
                      > -->
                  </h3>
                  <p class="mb-1">
                    Client - Enter full name
                  </p>
                  <v-text-field
                    label="Full Name"
                    v-model="clientPrintName"
                    outlined
                    hide-details
                    class="mb-4"
                    required
                    :rules="[(v) => !!v || 'Client Name required']"
                  ></v-text-field>
                  <p class="mb-1" v-if="showClientEmail">
                    Client - Email (Client will receive a copy)
                  </p>
                  <v-text-field
                    v-if="showClientEmail"
                    label="Email Address"
                    v-model="clientEmail"
                    type="email"
                    outlined
                    :rules="[
                      (v) =>
                        !v ||
                        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                        'E-mail must be valid',
                    ]"
                    class="mb-4"
                  ></v-text-field>
                  <p class="mb-1">
                    Client - Please sign below within green box<br />
                    <strong class="black--text"
                      >* I agree that all work has been completed to my
                      satisfaction.</strong
                    >
                  </p>
                  <vueSignature
                    ref="clientSignature"
                    :sigOption="option"
                    :w="'100%'"
                    :h="'160px'"
                    style="border: 4px solid #4caf50;border-radius: 5px;padding: 5px;"
                    class="mb-2"
                  ></vueSignature>
                  <v-btn
                    class="mr-2"
                    small
                    outlined
                    text
                    @click="clear('clientSignature')"
                    >Clear</v-btn
                  >
                  <v-btn
                    class="mr-2"
                    small
                    outlined
                    text
                    @click="undo('clientSignature')"
                    >Undo</v-btn
                  >
                </v-col>
              </v-row>
              <v-row class="mt-4">
                <v-col xs="12">
                  <v-textarea
                    outlined
                    label="Additional Closing Notes (optional)"
                    v-model="closeNotes"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row class="mt-4">
                <v-col xs="12" sm="6">
                  <v-btn
                    class="mr-2"
                    :disabled="submitting"
                    block
                    color="primary"
                    @click="updateTruckRequest"
                    >Close Truck Request</v-btn
                  >
                </v-col>
                <v-col xs="12" sm="6">
                  <v-btn
                    class="mr-2"
                    :disabled="submitting"
                    block
                    v-if="
                      truckRequest.status == 'scheduled' &&
                        truckRequest.closeDate &&
                        ['Truck Manager', 'Yard Manager'].includes(user.role)
                    "
                    color="secondary"
                    @click="forceClose"
                    >Force Close</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
        <v-snackbar v-model="snack" :timeout="5000" :color="snackColor">
          {{ snackText }}
          <v-btn text @click="snack = false">Close</v-btn>
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import fb from "@/main";
import utils from "@/helpers/utils";
import moment from "moment";
import { mapState } from "vuex";
import Vue from "vue";
import vueSignature from "vue-signature";
import truckRequestTicket from "@/components/truckRequests/truckRequestTicket";
import { sumBy } from "lodash";
Vue.use(vueSignature);
export default {
  components: {
    vueSignature,
    truckRequestTicket,
  },
  data() {
    return {
      truckRequest: null,
      valid: false,
      submitting: false,
      snack: false,
      snackColor: "",
      snackText: "",
      option: {
        penColor: "rgb(0, 0, 0)",
        backgroundColor: "rgb(255,255,255)",
      },
      // form data
      client: "",
      clientEmail: "",
      showClientEmail: false,
      clientPrintName: "",
      closeNotes: "",
      materialTypeBreakdown: [],
      currentMaterial: null,
      currentPickupType: null,
      additionalPickupType: [],
      // Simplified material and quantity tracking
      simplifiedMaterialTypes: [],
      quantityBreakdown: {
        looseYardsRegular: 0,
        looseYardsHeavy: 0,
        minisRegular: 0,
        minisHeavy: 0,
      },
      fullTruck: false,
    };
  },
  computed: {
    ...mapState(["user"]),
    materialPercentTotal() {
      return sumBy(this.materialTypeBreakdown, "percent");
    },
    // Computed properties for simplified quantity breakdown
    totalLooseYards() {
      return (
        (this.quantityBreakdown.looseYardsRegular || 0) +
        (this.quantityBreakdown.looseYardsHeavy || 0)
      );
    },
    totalMinis() {
      return (
        (this.quantityBreakdown.minisRegular || 0) +
        (this.quantityBreakdown.minisHeavy || 0)
      );
    },
    hasLooseYards() {
      return this.totalLooseYards > 0;
    },
    hasMinis() {
      return this.totalMinis > 0;
    },
    effectivePickupType() {
      if (this.hasLooseYards && this.hasMinis) {
        return "Both";
      } else if (this.hasLooseYards) {
        return "Loose Yards";
      } else if (this.hasMinis) {
        return "Mini Containers";
      }
      return null;
    },
    totalQuantity() {
      return this.totalLooseYards + this.totalMinis;
    },
  },
  watch: {
    fullTruck(newVal) {
      if (newVal) {
        // When Full Truck is toggled ON
        this.quantityBreakdown.looseYardsRegular = 25;
        this.quantityBreakdown.looseYardsHeavy = 0;
        this.quantityBreakdown.minisRegular = 0;
        this.quantityBreakdown.minisHeavy = 0;
      }
      // When toggled OFF, fields remain enabled with their current values
    },
  },
  async created() {
    this.getTruckRequest();
  },
  methods: {
    async getTruckRequest() {
      try {
        const truckRequestRes = await fb.db
          .collection("truckRequests")
          .doc(this.$route.params.id)
          .get();
        this.truckRequest = truckRequestRes.data();
        console.log(truckRequestRes.data());
        this.materialTypeBreakdown = this.truckRequest.materialType
          .filter((m) => m !== "C&D")
          .map((m) => {
            return {
              material: m,
              percent: 0,
            };
          });
      } catch (error) {
        alert("Error getting truck request.");
      }
    },
    async updateTruckRequest() {
      // Validation for simplified materials and quantities
      if (this.truckRequest.requestType === "Packer") {
        const hasValidQuantity =
          this.quantityBreakdown.looseYardsRegular >= 1 ||
          this.quantityBreakdown.looseYardsHeavy >= 1 ||
          this.quantityBreakdown.minisRegular >= 1 ||
          this.quantityBreakdown.minisHeavy >= 1;

        if (!hasValidQuantity) {
          alert(
            "Please enter at least a quantity of 1 for one of the 4 options."
          );
          return;
        }
        if (
          !this.simplifiedMaterialTypes ||
          this.simplifiedMaterialTypes.length === 0
        ) {
          alert("Please select at least one material type.");
          return;
        }
      }
      if (this.$refs.clientSignature.isEmpty()) {
        alert("Signature required.");
        return;
      }
      if (!this.clientPrintName) {
        alert("Full name required.");
        return;
      }
      this.submitting = true;
      var clientSigRef = fb.signatureStorage.child(
        `truck-request-signatures/client-${
          this.$route.params.id
        }-${moment().unix()}.png`
      );
      var clientSignatureImg = this.$refs.clientSignature.save();
      // Data URL string
      const imgSnapClient = await clientSigRef.putString(
        clientSignatureImg,
        "data_url"
      );
      const clientImgUrl = await imgSnapClient.ref.getDownloadURL();

      // Quantities the driver confirmed on the closing screen. These are what
      // actually move the yard's count, so they get persisted onto the request
      // below rather than discarded - otherwise the ticket keeps showing the
      // originally requested amount and silently disagrees with the inventory.
      // `Math.abs` because some requests store the pickup qty as a negative
      // number, which the display already normalises the same way.
      const confirmedMiniPickup = Math.abs(
        Number(this.truckRequest.miniPickupQty) || 0
      );
      const confirmedMiniDropoff = Math.abs(
        Number(this.truckRequest.miniDropoffQty) || 0
      );

      if (this.truckRequest.requestType == "Mini Pickup/Dropoff") {
        const miniRef = fb.db
          .collection("miniContainers")
          .doc(this.truckRequest.jobSite.id);
        const ts = moment().unix();
        const miniDelta = confirmedMiniDropoff - confirmedMiniPickup;
        // The read-modify-write has to be atomic: two drivers closing requests
        // for the same job site at once would otherwise clobber each other.
        await fb.db.runTransaction(async (t) => {
          const currentMiniContainerDoc = await t.get(miniRef);
          const existingCount = currentMiniContainerDoc.exists
            ? Number(currentMiniContainerDoc.data().count) || 0
            : 0;
          // A site can never physically hold a negative number of minis.
          const newMiniCount = Math.max(0, existingCount + miniDelta);
          const historyEntry = {
            originalAmount: existingCount,
            newAmount: newMiniCount,
            note: "",
            updateBy: this.user,
            createDate: fb.timestamp,
            updateType: "truckRequest",
            truckRequest: this.$route.params.id,
          };
          if (currentMiniContainerDoc.exists) {
            // Doc exists: a dotted field path nests correctly under `history`.
            t.update(miniRef, {
              [`history.${ts}`]: historyEntry,
              count: newMiniCount,
            });
          } else {
            // First-ever request: `.set()` treats a dotted key as a LITERAL
            // field name (creating a broken "history.<ts>" field that the
            // History button can't read), so build the nested map explicitly.
            t.set(miniRef, {
              count: newMiniCount,
              history: { [ts]: historyEntry },
            });
          }
        });
      }

      // Look up the truck assigned to the driver (non-blocking)
      let truckId = null;
      let truckName = null;
      try {
        if (this.truckRequest.scheduledDriver && this.truckRequest.scheduledDriver.uid) {
          const truckSnapshot = await fb.db
            .collection("trucks")
            .where("driver.uid", "==", this.truckRequest.scheduledDriver.uid)
            .limit(1)
            .get();
          if (!truckSnapshot.empty) {
            truckId = truckSnapshot.docs[0].id;
            truckName = utils.truckName(truckSnapshot.docs[0].data()) || null;
          }
        }
      } catch (err) {
        console.warn("Could not look up truck name:", err);
      }

      // Prepare update payload
      const updatePayload = {
        status: "closed",
        clientSignatureImage: clientImgUrl,
        clientPrintName: this.clientPrintName,
        closedBy: this.user,
        closeDate: fb.timestamp,
        closeNotes: this.closeNotes,
        closingQty: this.truckRequest.qty || 0,
        closingMaterialType: this.truckRequest.materialType,
        materialTypeBreakdown: this.materialTypeBreakdown,
        additionalPickupType: this.additionalPickupType,
        truckId: truckId,
        truckName: truckName,
      };

      // Persist what the driver actually confirmed, so the closing details on
      // the ticket reflect the numbers the mini count was moved by.
      if (this.truckRequest.requestType === "Mini Pickup/Dropoff") {
        updatePayload.closingMiniPickupQty = confirmedMiniPickup;
        updatePayload.closingMiniDropoffQty = confirmedMiniDropoff;
      }

      // Add simplified materials and quantity data structure for Packer requests only (new keys)
      if (this.truckRequest.requestType === "Packer") {
        updatePayload.driverMaterialTypes = this.simplifiedMaterialTypes;
        updatePayload.driverQuantityBreakdown = this.quantityBreakdown;
        updatePayload.driverEffectivePickupType = this.effectivePickupType;
      }

      await fb.db
        .collection("truckRequests")
        .doc(this.$route.params.id)
        .update(updatePayload);
      this.submitting = false;
      this.getTruckRequest();
      const truckRequestEmails = await fb.functions.httpsCallable(
        "truckRequestEmails"
      );
      truckRequestEmails({
        order: this.truckRequest,
        emailType: "Closed",
      });
    },
    clear(sigRef) {
      this.$refs[sigRef].clear();
    },
    undo(sigRef) {
      this.$refs[sigRef].undo();
    },
    reset() {
      // form reset
      this.client = "";
      this.labor = [];
      this.scopeCompleted = "";
      this.partsMaterials = [];
      this.dateCompleted = null;
      this.foremanPrintName = "";
      this.clientPrintName = "";
      this.showClientEmail = false;
      this.clientEmail = "";
      this.clear("foremanSignature");
      this.clear("clientSignature");
      this.debrisYardage = 0;
      this.materialTypeBreakdown = [];
    },
    addMaterial() {
      const material = { material: this.currentMaterial, percent: 0 };
      this.materialTypeBreakdown.push(material);
      this.currentMaterial = null;
    },
    addPickupType() {
      const pickup = { type: this.currentPickupType, qty: 0 };
      this.additionalPickupType.push(pickup);
      this.currentPickupType = null;
    },
    async forceClose() {
      this.submitting = true;
      try {
        // Look up the truck assigned to the driver (non-blocking)
        let truckId = null;
        let truckName = null;
        try {
          if (this.truckRequest.scheduledDriver && this.truckRequest.scheduledDriver.uid) {
            const truckSnapshot = await fb.db
              .collection("trucks")
              .where("driver.uid", "==", this.truckRequest.scheduledDriver.uid)
              .limit(1)
              .get();
            if (!truckSnapshot.empty) {
              truckId = truckSnapshot.docs[0].id;
              truckName = utils.truckName(truckSnapshot.docs[0].data()) || null;
            }
          }
        } catch (err) {
          console.warn("Could not look up truck name:", err);
        }

        await fb.db
          .collection("truckRequests")
          .doc(this.$route.params.id)
          .update({
            status: "closed",
            forceClose: true,
            truckId: truckId,
            truckName: truckName,
          });
        this.getTruckRequest();
        this.submitting = false;
        this.snackText = "Truck Request Closed";
        this.snackColor = "success";
        this.snack = true;
      } catch (error) {
        this.submitting = false;
        this.snackText = "Error closing truck request";
        this.snackColor = "error";
        this.snack = true;
      }
    },
  },
};
</script>

<style scoped>
.small-col {
  width: 60px;
}
@media (min-width: 600px) {
  .small-col {
    width: 90px;
  }
}
.med-col {
  width: 100px;
}
</style>
